module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "f-loading"
  }, [_c('div', {
    staticClass: "load-gif"
  }), _vm._v(" "), (_vm.hasText) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("加载中...")]) : _vm._e()])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2a75d465", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-2a75d465!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/loading/loading.vue
// module id = 30
// module chunks = 0